import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const StatBox = () => {
  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* BASIC STAT BOXES */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Stat Boxes</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Simple Stat</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600">
              <p className="text-xs text-slate-500 mb-1">Total Users</p>
              <p className="text-3xl font-bold text-slate-200">1,234</p>
              <p className="text-xs text-amber-400 mt-1"> 12% this month</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-4 bg-slate-950 rounded">
  <p className="text-xs text-slate-500">Label</p>
  <p className="text-3xl font-bold">1,234</p>
  <p className="text-xs text-amber-400"> 12%</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Stat with Icon</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 flex items-center gap-4">
              <div className="text-4xl"></div>
              <div>
                <p className="text-xs text-slate-500">Active Members</p>
                <p className="text-2xl font-bold text-slate-200">523</p>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-4 bg-slate-950 rounded flex items-center gap-4">
  <div className="text-4xl"></div>
  <div>
    <p className="text-xs text-slate-500">Label</p>
    <p className="text-2xl font-bold">523</p>
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Colored Stat</label>
            <div className="p-4 bg-gradient-to-br from-amber-900 to-slate-900 rounded border border-amber-600">
              <p className="text-xs text-amber-400 mb-1">Revenue</p>
              <p className="text-3xl font-bold text-amber-100">$45.8K</p>
              <p className="text-xs text-amber-300 mt-1"> 8% vs last period</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-4 bg-gradient-to-br from-amber-900 border-amber-600">
  <p className="text-amber-400">Label</p>
  <p className="text-amber-100">Value</p>
  <p className="text-amber-300"> Change</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Compact Stat</label>
            <div className="p-2 bg-slate-950 rounded border border-slate-600 text-center">
              <p className="text-sm font-bold text-slate-200">892</p>
              <p className="text-xs text-slate-500">Orders</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-2 bg-slate-950 rounded text-center">
  <p className="text-sm font-bold">892</p>
  <p className="text-xs">Orders</p>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Stat with Progress</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600">
              <div className="flex justify-between items-center mb-2">
                <p className="text-xs text-slate-400">Completion</p>
                  <span className="text-sm font-bold text-amber-400">75%</span>
              </div>
              <div className="w-full bg-slate-800 rounded h-2">
                <div className="bg-amber-400 h-full rounded" style={{width: "75%"}}></div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-4 bg-slate-950 rounded">
  <div className="flex justify-between mb-2">
    <p>Label</p>
    <span>75%</span>
  </div>
  <div className="w-full bg-slate-800 rounded h-2">
    <div className="bg-amber-400 h-full" style={{width: "75%"}} />
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Grid of Stats</label>
            <div className="grid grid-cols-2 gap-2">
              {["45", "89", "23", "156"].map(num => (
                <div key={num} className="p-2 bg-slate-950 rounded border border-slate-600 text-center">
                  <p className="font-bold text-sm">{num}</p>
                </div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="grid grid-cols-2 gap-2">
  {stats.map(num => (
    <div className="p-2 bg-slate-950 rounded font-bold">
      {num}
    </div>
  ))}
</div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED STATS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Stats</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Dashboard Card</label>
            <div className="p-4 bg-gradient-to-br from-slate-800 to-slate-900 rounded-lg border border-slate-600 shadow-lg">
              <div className="flex justify-between items-start mb-3">
                <div>
                  <p className="text-xs text-slate-500 font-medium">CONVERSIONS</p>
                  <p className="text-3xl font-bold text-slate-100">3,427</p>
                </div>
                <span className="text-2xl"></span>
              </div>
              <div className="px-3 py-1 bg-green-900 text-green-300 text-xs rounded-full w-fit">
                 4% from last week
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="p-4 bg-gradient-to-br from-slate-800 to-slate-900 rounded-lg border shadow-lg">
  <div className="flex justify-between items-start mb-3">
    <div>
      <p className="text-xs">LABEL</p>
      <p className="text-3xl font-bold">3,427</p>
    </div>
    <span></span>
  </div>
  <div className="bg-green-900 text-green-300 text-xs"> 4%</div>
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatBox;


